// Submit TAT Analysis Constants
export const SUBMIT_TAT_ANALYSIS_REQUEST = 'SUBMIT_TAT_ANALYSIS_REQUEST'
export const SUBMIT_TAT_ANALYSIS_SUCCESS = 'SUBMIT_TAT_ANALYSIS_SUCCESS'
export const SUBMIT_TAT_ANALYSIS_FAIL = 'SUBMIT_TAT_ANALYSIS_FAIL'
export const SUBMIT_TAT_ANALYSIS_RESET = 'SUBMIT_TAT_ANALYSIS_RESET'

// Get My TAT Analysis Constants
export const GET_MY_TAT_ANALYSIS_REQUEST = 'GET_MY_TAT_ANALYSIS_REQUEST'
export const GET_MY_TAT_ANALYSIS_SUCCESS = 'GET_MY_TAT_ANALYSIS_SUCCESS'
export const GET_MY_TAT_ANALYSIS_FAIL = 'GET_MY_TAT_ANALYSIS_FAIL'
export const GET_MY_TAT_ANALYSIS_RESET = 'GET_MY_TAT_ANALYSIS_RESET'

// Get TAT Statistics Constants
export const GET_TAT_STATISTICS_REQUEST = 'GET_TAT_STATISTICS_REQUEST'
export const GET_TAT_STATISTICS_SUCCESS = 'GET_TAT_STATISTICS_SUCCESS'
export const GET_TAT_STATISTICS_FAIL = 'GET_TAT_STATISTICS_FAIL'
export const GET_TAT_STATISTICS_RESET = 'GET_TAT_STATISTICS_RESET'

// Update TAT Analysis Constants
export const UPDATE_TAT_ANALYSIS_REQUEST = 'UPDATE_TAT_ANALYSIS_REQUEST'
export const UPDATE_TAT_ANALYSIS_SUCCESS = 'UPDATE_TAT_ANALYSIS_SUCCESS'
export const UPDATE_TAT_ANALYSIS_FAIL = 'UPDATE_TAT_ANALYSIS_FAIL'
export const UPDATE_TAT_ANALYSIS_RESET = 'UPDATE_TAT_ANALYSIS_RESET'

// Delete TAT Analysis Constants
export const DELETE_TAT_ANALYSIS_REQUEST = 'DELETE_TAT_ANALYSIS_REQUEST'
export const DELETE_TAT_ANALYSIS_SUCCESS = 'DELETE_TAT_ANALYSIS_SUCCESS'
export const DELETE_TAT_ANALYSIS_FAIL = 'DELETE_TAT_ANALYSIS_FAIL'
export const DELETE_TAT_ANALYSIS_RESET = 'DELETE_TAT_ANALYSIS_RESET'


// Get TAT Analysis Report Constants
export const GET_TAT_ANALYSIS_REPORT_REQUEST = 'GET_TAT_ANALYSIS_REPORT_REQUEST'
export const GET_TAT_ANALYSIS_REPORT_SUCCESS = 'GET_TAT_ANALYSIS_REPORT_SUCCESS'
export const GET_TAT_ANALYSIS_REPORT_FAIL = 'GET_TAT_ANALYSIS_REPORT_FAIL'
export const GET_TAT_ANALYSIS_REPORT_RESET = 'GET_TAT_ANALYSIS_REPORT_RESET'